import type { StreamsListRow } from "@/admin/entities/streams";
import type { StreamsListQueryQueryType } from "@/types/graphql/admin.generated";

export function getTableData(data: unknown): {
  nodes: StreamsListRow[];
  count: number;
} {
  const contents = (data as StreamsListQueryQueryType)?.contents;
  if (!contents || !contents.nodes) {
    return { nodes: [], count: 0 };
  }
  return contents;
}

export function mapColumns(stream: StreamsListRow) {
  return [
    stream.id,
    stream.preview,
    stream,
    stream.totalViews,
    stream.platform,
    stream.stream,
    stream.stream?.startAt ?? null,
    stream.createdAt,
    stream.deletedAt,
  ];
}
